import React from 'react';
import PageMeta from 'app/components/common/PageMeta';
import { T } from 'app/components/localization';

/**
 * Renders a completely blank white page with no header/footer/content, but uses <PageMeta> to set
 * the <title>. Meant to be rendered while waiting for a redirect that we want to be as invisible as
 * possible, such as automatic oauth redirects.
 */
const RedirectingPage: React.FC = () => (
  <T>{t =>
    <PageMeta title={t('page.redirecting.title')} />
  }</T>
);

export default RedirectingPage;
